/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type CreateDecorationMutationVariables = Exact<{
  fileName?: string | null | undefined;
  name?: string | null | undefined;
  decorationId?: string | null | undefined;
}>;

export type CreateDecorationMutation = {
  createDecoration: { status: boolean | null } | null;
};

export type MineDecorationsQueryVariables = Exact<{ [key: string]: never }>;

export type MineDecorationsQuery = {
  mineDecorations: Array<{
    config: string | null;
    fileName: string | null;
    name: string | null;
    published: boolean | null;
    status: boolean | null;
    decorationId: string | null;
    fxConfig: string | null;
  } | null> | null;
};

export type UpdateDecorationMutationVariables = Exact<{
  decorationId: string;
  update: Types.DecorationUpdate;
}>;

export type UpdateDecorationMutation = {
  updateDecoration: {
    config: string | null;
    fileName: string | null;
    name: string | null;
    published: boolean | null;
    status: boolean | null;
    decorationId: string | null;
    fxConfig: string | null;
  } | null;
};

export type MineDemoDecorationsQueryVariables = Exact<{ [key: string]: never }>;

export type MineDemoDecorationsQuery = {
  mideDecorationDemos: Array<{
    config: string | null;
    decorationDemoId: string | null;
  } | null> | null;
};

export type MineDecorationFxListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MineDecorationFxListQuery = {
  mineDecorationFxList: Array<{
    config: string | null;
    decorationFxId: string | null;
    name: string | null;
  } | null> | null;
};

export type InsertDecorationDemoMutationVariables = Exact<{
  demoDecorationId?: string | null | undefined;
}>;

export type InsertDecorationDemoMutation = {
  insertDecorationDemo: {
    config: string | null;
    decorationDemoId: string | null;
  } | null;
};

export type InsertDecorationFxMutationVariables = Exact<{
  name: string;
  config: string;
  decorationFxId?: string | null | undefined;
}>;

export type InsertDecorationFxMutation = {
  insertDecorationFx: {
    config: string | null;
    decorationFxId: string | null;
    name: string | null;
  } | null;
};

export type UpdateDemoDecorationMutationVariables = Exact<{
  demoDecorationId?: string | null | undefined;
  config?: string | null | undefined;
}>;

export type UpdateDemoDecorationMutation = {
  updateDecorationDemo: {
    config: string | null;
    decorationDemoId: string | null;
  } | null;
};

export type UpdateDecorationFxMutationVariables = Exact<{
  decorationFxId: string;
  config: string;
}>;

export type UpdateDecorationFxMutation = {
  updateDecorationFx: {
    config: string | null;
    decorationFxId: string | null;
    name: string | null;
  } | null;
};

export type LabsListQueryVariables = Exact<{ [key: string]: never }>;

export type LabsListQuery = {
  getLabs: Array<{
    labId: number | null;
    label: string | null;
    organizationId: string | null;
  } | null> | null;
};

export type WallDecorSceneFragment = {
  workName: string | null;
  labs: Array<string | null> | null;
  wallDecorSceneId: string | null;
  elementsCount: number | null;
  isPublished: boolean | null;
  currentCost: Array<{
    price: number | null;
    code: string | null;
  } | null> | null;
  pieces: Array<{
    wallDecorPieceId: string | null;
    flip: boolean | null;
    x: number | null;
    y: number | null;
    currentCost: Array<{
      code: string | null;
      price: number | null;
    } | null> | null;
    model: { gltfModelId: string | null; fileName: string | null } | null;
  } | null> | null;
};

export type InsertWallDecorSceneMutationVariables = Exact<{
  organizationId: string;
  wallDecorSceneId: string;
  workName: string;
}>;

export type InsertWallDecorSceneMutation = {
  insertWallDecorScene: {
    workName: string | null;
    labs: Array<string | null> | null;
    wallDecorSceneId: string | null;
    elementsCount: number | null;
    isPublished: boolean | null;
    currentCost: Array<{
      price: number | null;
      code: string | null;
    } | null> | null;
    pieces: Array<{
      wallDecorPieceId: string | null;
      flip: boolean | null;
      x: number | null;
      y: number | null;
      currentCost: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      model: { gltfModelId: string | null; fileName: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetMineWallDecorsQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetMineWallDecorsQuery = {
  getMineWallDecorScenes: Array<{
    workName: string | null;
    labs: Array<string | null> | null;
    wallDecorSceneId: string | null;
    elementsCount: number | null;
    isPublished: boolean | null;
    currentCost: Array<{
      price: number | null;
      code: string | null;
    } | null> | null;
    pieces: Array<{
      wallDecorPieceId: string | null;
      flip: boolean | null;
      x: number | null;
      y: number | null;
      currentCost: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      model: { gltfModelId: string | null; fileName: string | null } | null;
    } | null> | null;
  } | null> | null;
};

export type UpdateWallDecorSceneMutationVariables = Exact<{
  organizationId: string;
  wallDecorSceneId: string;
  update?: Types.WallDecorSceneInput | null | undefined;
}>;

export type UpdateWallDecorSceneMutation = {
  updateWallDecorScene: {
    workName: string | null;
    labs: Array<string | null> | null;
    wallDecorSceneId: string | null;
    elementsCount: number | null;
    isPublished: boolean | null;
    currentCost: Array<{
      price: number | null;
      code: string | null;
    } | null> | null;
    pieces: Array<{
      wallDecorPieceId: string | null;
      flip: boolean | null;
      x: number | null;
      y: number | null;
      currentCost: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      model: { gltfModelId: string | null; fileName: string | null } | null;
    } | null> | null;
  } | null;
};

export const WallDecorSceneFragmentDoc = gql`
  fragment WallDecorScene on WallDecorScene {
    workName
    labs
    wallDecorSceneId
    currentCost {
      price
      code
    }
    elementsCount
    isPublished
    pieces {
      wallDecorPieceId
      currentCost {
        code
        price
      }
      model {
        gltfModelId
        fileName
      }
      flip
      x
      y
    }
  }
`;
export const CreateDecorationDocument = gql`
  mutation createDecoration($fileName: ID, $name: String, $decorationId: ID) {
    createDecoration(
      name: $name
      fileName: $fileName
      decorationId: $decorationId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDecorationGQL extends Apollo.Mutation<
  CreateDecorationMutation,
  CreateDecorationMutationVariables
> {
  document = CreateDecorationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MineDecorationsDocument = gql`
  query mineDecorations {
    mineDecorations {
      config
      fileName
      name
      published
      status
      decorationId
      fxConfig
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineDecorationsGQL extends Apollo.Query<
  MineDecorationsQuery,
  MineDecorationsQueryVariables
> {
  document = MineDecorationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDecorationDocument = gql`
  mutation updateDecoration($decorationId: ID!, $update: DecorationUpdate!) {
    updateDecoration(decorationId: $decorationId, update: $update) {
      config
      fileName
      name
      published
      status
      decorationId
      fxConfig
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDecorationGQL extends Apollo.Mutation<
  UpdateDecorationMutation,
  UpdateDecorationMutationVariables
> {
  document = UpdateDecorationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MineDemoDecorationsDocument = gql`
  query MineDemoDecorations {
    mideDecorationDemos {
      config
      decorationDemoId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineDemoDecorationsGQL extends Apollo.Query<
  MineDemoDecorationsQuery,
  MineDemoDecorationsQueryVariables
> {
  document = MineDemoDecorationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MineDecorationFxListDocument = gql`
  query mineDecorationFxList {
    mineDecorationFxList {
      config
      decorationFxId
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineDecorationFxListGQL extends Apollo.Query<
  MineDecorationFxListQuery,
  MineDecorationFxListQueryVariables
> {
  document = MineDecorationFxListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertDecorationDemoDocument = gql`
  mutation insertDecorationDemo($demoDecorationId: ID) {
    insertDecorationDemo(decorationDemoId: $demoDecorationId) {
      config
      decorationDemoId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertDecorationDemoGQL extends Apollo.Mutation<
  InsertDecorationDemoMutation,
  InsertDecorationDemoMutationVariables
> {
  document = InsertDecorationDemoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertDecorationFxDocument = gql`
  mutation insertDecorationFx(
    $name: String!
    $config: String!
    $decorationFxId: ID
  ) {
    insertDecorationFx(
      name: $name
      config: $config
      decorationFxId: $decorationFxId
    ) {
      config
      decorationFxId
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertDecorationFxGQL extends Apollo.Mutation<
  InsertDecorationFxMutation,
  InsertDecorationFxMutationVariables
> {
  document = InsertDecorationFxDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDemoDecorationDocument = gql`
  mutation updateDemoDecoration($demoDecorationId: ID, $config: String) {
    updateDecorationDemo(decorationDemoId: $demoDecorationId, config: $config) {
      config
      decorationDemoId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDemoDecorationGQL extends Apollo.Mutation<
  UpdateDemoDecorationMutation,
  UpdateDemoDecorationMutationVariables
> {
  document = UpdateDemoDecorationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDecorationFxDocument = gql`
  mutation updateDecorationFx($decorationFxId: ID!, $config: String!) {
    updateDecorationFx(decorationFxId: $decorationFxId, config: $config) {
      config
      decorationFxId
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDecorationFxGQL extends Apollo.Mutation<
  UpdateDecorationFxMutation,
  UpdateDecorationFxMutationVariables
> {
  document = UpdateDecorationFxDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LabsListDocument = gql`
  query LabsList {
    getLabs {
      labId
      label
      organizationId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LabsListGQL extends Apollo.Query<
  LabsListQuery,
  LabsListQueryVariables
> {
  document = LabsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertWallDecorSceneDocument = gql`
  mutation insertWallDecorScene(
    $organizationId: ID!
    $wallDecorSceneId: ID!
    $workName: String!
  ) {
    insertWallDecorScene(
      organizationId: $organizationId
      wallDecorSceneId: $wallDecorSceneId
      workName: $workName
    ) {
      ...WallDecorScene
    }
  }
  ${WallDecorSceneFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class InsertWallDecorSceneGQL extends Apollo.Mutation<
  InsertWallDecorSceneMutation,
  InsertWallDecorSceneMutationVariables
> {
  document = InsertWallDecorSceneDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMineWallDecorsDocument = gql`
  query getMineWallDecors($organizationId: ID!) {
    getMineWallDecorScenes(organizationId: $organizationId) {
      ...WallDecorScene
    }
  }
  ${WallDecorSceneFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetMineWallDecorsGQL extends Apollo.Query<
  GetMineWallDecorsQuery,
  GetMineWallDecorsQueryVariables
> {
  document = GetMineWallDecorsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateWallDecorSceneDocument = gql`
  mutation updateWallDecorScene(
    $organizationId: ID!
    $wallDecorSceneId: ID!
    $update: WallDecorSceneInput
  ) {
    updateWallDecorScene(
      organizationId: $organizationId
      wallDecorSceneId: $wallDecorSceneId
      update: $update
    ) {
      ...WallDecorScene
    }
  }
  ${WallDecorSceneFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateWallDecorSceneGQL extends Apollo.Mutation<
  UpdateWallDecorSceneMutation,
  UpdateWallDecorSceneMutationVariables
> {
  document = UpdateWallDecorSceneDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
